module.exports = __webpack_public_path__ + "assets/img/3_1156.7fdb6889.jpg";